import { useTranslation } from "react-i18next";
import { Box, TextField, IconButton } from "@mui/material";

import { ChatSendButtonIcon } from "../../../../../assets/icons/service-details-icons";

const ChatInput = ({
  onSendMessage,
  onKeyDown,
  scrollToBottomOfChatContainer,
  chatInputRef,
}: {
  onSendMessage: () => Promise<void>;
  onKeyDown: (event: React.KeyboardEvent) => Promise<void>;
  scrollToBottomOfChatContainer: () => void;
  chatInputRef: React.RefObject<HTMLInputElement>;
}) => {
  const { t, i18n } = useTranslation("chat");

  const handleSendMessage = async () => {
    await onSendMessage();
    scrollToBottomOfChatContainer();
  };

  const handleKeyDown = async (event: React.KeyboardEvent) => {
    await onKeyDown(event);
    if (event.key === "Enter" && !event.shiftKey) {
      scrollToBottomOfChatContainer();
    }
  };

  return (
    <Box sx={styles.container}>
      <TextField sx={styles.input} placeholder={t("sendMessage")} onKeyDown={handleKeyDown} inputRef={chatInputRef} />
      <IconButton sx={styles.sendButton} onClick={handleSendMessage}>
        <ChatSendButtonIcon sx={styles.sendButtonIcon(i18n.language)} />
      </IconButton>
    </Box>
  );
};

export default ChatInput;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  input: {
    flex: 1,
    width: "100%",
    height: "100%",

    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",

    borderRadius: "40px",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    background: "var(--Base-White, #FFF)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    "& .MuiOutlinedInput-root": { padding: "0 16px !important" },
    "& .MuiInputBase-input": { padding: "10px 0 !important" },
  },
  sendButton: {
    border: "1px solid var(--Brand-600, #008B07) !important",
    background: "var(--Brand-600, #008B07) !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  sendButtonIcon: (language: "ar" | "en") => ({
    transform: language === "ar" ? "scaleX(-1)" : "scaleX(1)",
  }),
};
